export default function formatDate(date) {
    if (!date) {
        return '';
    }
    var zRemovedDate = date.includes('Z') ? date.replace('Z','') : date;
    var d = new Date(zRemovedDate),
        // month = d.toLocaleString('default',{month : 'short'}),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    if (day.length < 2) 
        day = '0' + day;
    if (month.length < 2)
        month = '0' + month;
    var Hour = d.getHours() > 12 ? d.getHours() - 12 : d.getHours()
    var min = d.getMinutes()
    var ampm = d.getHours() < 12 ? "am" : "pm"
    if (Hour < 10)
        Hour = '0' + Hour
    if (min < 10)
        min = '0' + min
    
    var datee = [day, month, year].join('-')
    var time = [Hour, min].join(':')
    // console.log(datee,time,"MMM")
    return [datee, time, ampm].join(' ');
}
